/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  비토리지 OpenAPI 문서 데이터
 * ════════════════════════════════════════════════════════════════════════════════
 *  - 화면(StoreApiDocsPg)과 배포문서(PDF/PPTX)가 동일한 원본을 사용하도록
 *    한 곳에서만 관리한다. => 코드가 바뀌면 화면/문서가 함께 갱신되어 항상 일관성 유지.
 *  - 배포문서는 scripts/buildStoreDocs.mjs 가 이 파일을 읽어 빌드 때 만들어낸다.
 *    (이 파일을 고쳤다면 'npm run docs:store' 로 문서도 다시 만들어야 한다.
 *     잊어도 __tests__/storeDocsFresh.test.js 가 알려준다)
 *  - 실제 구현된 컨트롤러/서비스의 경로·필드·에러코드와 1:1로 일치시켜야 한다.
 *      · 주문연동  : StoreOpenApiController.orderLink
 *      · 배송료조회 : ShipPriceController.checkShippingFee
 *      · 에러코드  : common/ApiErrorCode.java
 * ════════════════════════════════════════════════════════════════════════════════
 */

const BASE = 'https://btorage.com';

export const API_DOC = {

    /* ── 서비스 안내 ─────────────────────────────────────────────────────── */
    serviceIntro: [
        '자체 해외배송이 불가할 경우 비토리지 API 연동을 통해 결과적으로 해외 고객들에게도 비토리지를 통해 판매/해외배송이 가능하게 됩니다.',
        '자체 해외배송이 가능하다고 해도 귀사의 고객님들은 다양한 배송사를 통한 해외배송 선택, 결제수단을 제공 받으실 수 있고 이 외에 통관, 문의 등의 번거로운 절차들을 비토리지에게 토스할 수 있습니다.',
        '구매대행 형식의 API 이므로 비용이 0원이며, 정산 및 계약 절차없이 비토리지의 API 버튼 삽입 및 연동만으로도 실제 해외 고객분들께 판매 및 매출 발생이 가능합니다.',
    ],

    couriers: [
        ['FedEx', '평균 1~2일 소요'],
        ['FedEx-E', '평균 2~5일 소요'],
        ['UPS', '평균 1~2일 소요'],
        ['UPS-E', '평균 2~5일 소요'],
        ['EMS', '평균 3~5일 소요'],
        ['EMS-Premium', '평균 3~4일 소요'],
        ['K-Packet', '평균 6~10일 소요'],
        ['Sea-Parcel', '평균 40~70일 소요'],
    ],

    payMethods: [
        '비토리지페이(해외카드) — 최초 해외카드정보 등록 후 설정한 비밀번호 6자리만 입력하여 간편결제',
        '비토리지페이(국내카드) — 최초 한국카드정보 등록 후 설정한 비밀번호 6자리만 입력하여 간편결제',
        '해외카드 (Visa/Master 등이 제휴된 해외카드로 카드정보 입력 후 결제)',
        '한국카드 (한국카드결제/네이버페이/카카오페이 등 여러 국내 결제수단 제공)',
        'Paypal',
        'WechatPay',
        'AliPay',
        '무통장 / 해외송금',
        '예치금결제 (위 결제수단을 통해 미리 충전 가능)',
        '적립금결제',
    ],

    inquiryChannels: [
        '카카오톡', '라인', '인스타그램', '위챗',
        '비토리지 1:1 실시간 비회원채팅',
        '비토리지 1:1 실시간 주문서채팅',
        '메일문의',
    ],

    etcServices: [
        '사용자 설정에 따라 단독포장 외에도 여러 한국 쇼핑몰 상품들을 주문하거나, 한 곳의 쇼핑몰에서 시차를 두고 상품을 추가하더라도 한 박스로 합포장',
        '관부가세 선납',
        '수출신고',
        '국가별 통관지원',
        '모든 절차에 대한 안내내용 주문서채팅과 메일로 자동 안내',
        'iOS & Android 앱 설치 시 모든 절차에 대한 모바일 앱 푸시알림 및 해외배송료 2% 추가 자동할인',
    ],

    processes: [
        {
            who: '쇼핑몰 절차',
            flow: '최초 API 연동 → 비토리지로부터 주문이 들어오면 비토리지 국내 물류센터로 배송 → 끝',
        },
        {
            who: '쇼핑몰 고객 절차',
            flow: '귀사의 개별 상품페이지 또는 장바구니 페이지에서 비토리지의 [Delivery] API 버튼 클릭 (상품데이터가 연동되어 전달) → 로그아웃 상태일 경우 가입 또는 로그인 → 비토리지 주문서 페이지 이동 (상품데이터 연동 출력) ※ 이때 단독배송 혹은 기존 진행중인 주문서와 합포장 선택이 가능합니다 → [1차 상품대금 결제] → 추후 비토리지 물류센터에서 패킹이 완료되면 해외배송사 선택 후 [2차 해외배송료 결제] → 끝',
        },
        {
            who: '비토리지 절차',
            flow: '귀사 고객으로부터 주문이 들어오면 귀사의 쇼핑몰에서 구매대행 주문 → 귀사로부터 모든 상품들이 물류센터에 배송되면 합포장 후 배송사별 기간/요금 등록 → 배송료 결제 시 해외로 출고 → 끝',
        },
    ],

    /* ── 연동 스니펫 ─────────────────────────────────────────────────────── */
    snippet: {
        script:
            `<!-- 비토리지 API 버튼 : </body> 직전에 한 줄만 삽입하세요 -->
<script src="${BASE}/btorage-button.js"
        data-btorage-key="{{API_KEY}}"
        data-btorage-theme="brand"
        data-btorage-shape="round"
        data-btorage-size="md"
        defer></script>`,

        dataset:
            `<!-- 상품 상세페이지 : 상품영역에 data-btorage-* 속성만 지정 -->
<div data-btorage-product
     data-btorage-name="여성 코튼 니트 가디건"
     data-btorage-option="아이보리 / M"
     data-btorage-quantity="1"
     data-btorage-price="39000"
     data-btorage-mall-ship-price="3000"
     data-btorage-url="https://myshop.co.kr/product/1234"
     data-btorage-width="41"
     data-btorage-vertical="31"
     data-btorage-height="28"
     data-btorage-weight="10.75">
  ... 기존 상품영역 ...
</div>

<!-- 장바구니 페이지 : 상품 행마다 그대로 반복하면 전체가 함께 연동됩니다 -->
<tr data-btorage-product
    data-btorage-name="여성 코튼 니트 가디건"
    data-btorage-option="아이보리 / M"
    data-btorage-quantity="2"
    data-btorage-price="39000"
    data-btorage-mall-ship-price="3000"
    data-btorage-url="https://myshop.co.kr/product/1234"
    data-btorage-width="41"
    data-btorage-vertical="31"
    data-btorage-height="28"
    data-btorage-weight="10.75">
  ... 기존 장바구니 행 ...
</tr>

<tr data-btorage-product
    data-btorage-name="베이직 크루넥 티셔츠"
    data-btorage-option="블랙 / L"
    data-btorage-quantity="1"
    data-btorage-price="18900"
    data-btorage-mall-ship-price="0"
    data-btorage-url="https://myshop.co.kr/product/5678"
    data-btorage-width="33"
    data-btorage-vertical="32"
    data-btorage-height="19"
    data-btorage-weight="2.5">
  ... 기존 장바구니 행 ...
</tr>`,

        mount:
            `<!-- 원하는 위치에 버튼을 넣고 싶을 때 (선택) -->
<div data-btorage-button></div>`,

        manual:
            `// 자체 프론트엔드에서 직접 호출하는 경우
const res = await fetch('${BASE}/api/open/v1/order-link', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-BTORAGE-API-KEY': '{{API_KEY}}'
  },
  body: JSON.stringify({
    visitorKey: 'v-abc123',   // 고객 구분용 (유입집계 중복제거)
    platform: 'WEB',          // WEB | APP
    products: [
      {
        name: '여성 코튼 니트 가디건',
        option: '아이보리 / M',
        quantity: 1,
        price: 39000,
        mallShipPrice: 3000,
        url: 'https://myshop.co.kr/product/1234',
        wid: 41,
        ver: 31,
        hei: 28,
        weight: 10.75
      }
    ]
  })
});

const body = await res.json();
if (body.success) {
  window.location.href = body.data.redirectUrl;   // 비토리지 주문서로 이동
} else {
  alert(body.message);                            // 예) Invalid API key.
}`,

        manualCurl:
            `# 언어에 상관없이 동일합니다. 서버(백엔드)에서 호출할 때도 같은 요청입니다.
curl -X POST "${BASE}/api/open/v1/order-link" \\
     -H "Content-Type: application/json" \\
     -H "X-BTORAGE-API-KEY: {{API_KEY}}" \\
     -d '{
       "visitorKey": "v-abc123",
       "platform": "WEB",
       "products": [
         {
           "name": "여성 코튼 니트 가디건",
           "option": "아이보리 / M",
           "quantity": 1,
           "price": 39000,
           "mallShipPrice": 3000,
           "url": "https://myshop.co.kr/product/1234",
           "wid": 41,
           "ver": 31,
           "hei": 28,
           "weight": 10.75
         }
       ]
     }'

# 응답의 data.redirectUrl 로 고객을 이동시키면 됩니다.
# {"success":true,"code":"OK","data":{"redirectUrl":"${BASE}/store/link?t=..."}}`,

        /* ── 앱 전용 ─────────────────────────────────────────────────────── */
        appServer:
            `# [앱] 자사 서버에서 호출합니다. API 키는 서버에만 두세요.
#      앱에서 직접 호출하면 디컴파일로 키가 추출될 수 있습니다.

curl -X POST "${BASE}/api/open/v1/order-link" \\
     -H "Content-Type: application/json" \\
     -H "X-BTORAGE-API-KEY: {{API_KEY}}" \\
     -d '{
       "visitorKey": "v-abc123",
       "platform": "APP",
       "products": [
         {
           "name": "여성 코튼 니트 가디건",
           "option": "아이보리 / M",
           "quantity": 1,
           "price": 39000,
           "mallShipPrice": 3000,
           "url": "https://myshop.co.kr/product/1234",
           "wid": 41,
           "ver": 31,
           "hei": 28,
           "weight": 10.75
         }
       ]
     }'

# 응답 — linkToken 과 redirectUrl 이 함께 옵니다. 둘 다 앱으로 내려주세요.
# {
#   "success": true,
#   "code": "OK",
#   "data": {
#     "linkToken": "a1b2c3d4...",
#     "companyName": "마이샵",
#     "redirectUrl": "${BASE}/store/link?t=a1b2c3d4..."
#   }
# }`,

        appMove:
            `// [앱] 받은 값으로 고객을 비토리지로 보냅니다.
//     ① 딥링크를 먼저 시도하면 비토리지 앱으로 곧바로 들어갑니다.
//     ② 실패하면(미설치) redirectUrl 을 외부 브라우저로 엽니다.
//        비토리지 진입 페이지가 앱/웹을 알아서 판단합니다.
//
// ※ 웹뷰로 열지 마세요. 로그인 세션·결제 PG·앱 딥링크가 웹뷰에서 제약을 받습니다.

── Android (Kotlin)
val deep = Uri.parse("btorage://StoreLinkPg?t=" + linkToken)
try {
    startActivity(Intent(Intent.ACTION_VIEW, deep))
} catch (e: ActivityNotFoundException) {
    // 비토리지 앱 미설치 -> 외부 브라우저
    startActivity(Intent(Intent.ACTION_VIEW, Uri.parse(redirectUrl)))
}

── iOS (Swift)
let deep = URL(string: "btorage://StoreLinkPg?t=\\(linkToken)")!
UIApplication.shared.open(deep, options: [:]) { ok in
    if !ok {
        // 비토리지 앱 미설치 -> 외부 브라우저(Safari)
        UIApplication.shared.open(URL(string: redirectUrl)!)
    }
}`,

        health:
            `curl -X GET "${BASE}/api/open/v1/health" \\
     -H "X-BTORAGE-API-KEY: {{API_KEY}}"

// 정상 응답
// {"success":true,"code":"OK","message":"Success",
//  "data":{"companyName":"마이샵","activated":true}}`,
    },

    /* ── 웹 / 앱 환경별 안내 ─────────────────────────────────────────────── */
    platformGuide: {
        guide: {
            web: [
                '스크립트 1줄과 상품영역 data 속성만 넣으면 버튼 생성부터 비토리지 호출까지 스크립트가 전부 처리합니다.',
                '별도의 서버 개발이 필요 없습니다. 아래 STEP 2 ~ STEP 4 를 그대로 따라주세요.',
                'React · Vue 처럼 화면을 스크립트로 그리는 쇼핑몰도 동일하게 동작합니다. 상품영역이 나중에 그려져도 자동으로 버튼을 다시 붙입니다.',
            ],
            app: [
                '앱에는 스크립트를 넣을 수 없으므로 [Delivery] 버튼을 앱 화면에 직접 만들어주세요. 모양은 [버튼 가이드라인] 을 따라주시면 됩니다.',
                '버튼을 누르면 자사 서버가 주문연동 API 를 호출하도록 만들어주세요. API 키는 앱에 넣지 말고 서버에만 두어야 합니다.',
                '응답으로 받은 redirectUrl 을 앱에서 열면 그 다음 절차는 비토리지가 모두 처리합니다. (비토리지 앱이 설치돼 있으면 앱으로, 없으면 모바일 웹으로 자동 연결)',
                '함께 내려오는 linkToken 으로 btorage://StoreLinkPg?t={linkToken} 을 먼저 시도하면 비토리지 앱으로 곧바로 보낼 수 있습니다. 실패하면 redirectUrl 로 열어주세요.',
            ],
        },
        order: {
            web: [
                '스크립트를 쓰면 이 API 를 직접 호출할 일이 없습니다. 자체 프론트엔드로 직접 붙이실 때만 참고하세요.',
                '브라우저에서 호출하므로 API 키가 노출됩니다. platform 은 WEB 으로 보내주세요.',
            ],
            app: [
                '반드시 자사 서버에서 호출해주세요. 앱에서 직접 호출하면 API 키가 추출될 수 있습니다.',
                'platform 을 APP 으로 보내면 유입 통계에서 웹과 앱을 나눠 볼 수 있습니다.',
                '응답의 redirectUrl 또는 linkToken 을 앱으로 전달해 화면을 이동시키면 됩니다.',
            ],
        },
        ship: {
            web: [
                '배송료조회는 조회 전용이라 웹에서 바로 호출하셔도 됩니다.',
                '상품 상세페이지에 예상 해외배송료를 미리 보여주는 용도로 많이 쓰입니다.',
                '모든 배송사별 반환되는 국제배송료는 관부가세가 제외된 배송료입니다.',
            ],
            app: [
                '앱에서도 자사 서버를 거쳐 호출하시길 권장합니다. (API 키 보호)',
                '국가코드와 부피·무게만 넘기면 배송사별 최종비용까지 계산되어 돌아옵니다.',
                '모든 배송사별 반환되는 국제배송료는 관부가세가 제외된 배송료입니다.',
            ],
        },
    },

    /* ── API 키 보관 안내 ────────────────────────────────────────────────── */
    keySecurity: {
        title: 'API 키 보관 주의',
        web: '스크립트 방식은 키가 페이지 소스에 노출됩니다. 이 키로 할 수 있는 일은 상품정보를 담은 진입주소를 발급받는 것뿐이라 결제·개인정보와는 무관합니다. 또한 비토리지는 브라우저에서 들어온 호출의 요청 도메인을 [내정보]에 등록하신 자사 URL 과 대조하므로, 키가 복사되어도 다른 사이트에서는 사용할 수 없습니다.',
        webDomain: '이 대조 때문에 [내정보]의 자사 URL 은 실제 서비스 주소와 같아야 합니다. www / m / shop 같은 서브도메인과 http·https·포트·경로 차이는 모두 같은 주소로 인정되며, 개발중인 localhost 와 사내망 주소(192.168.x, 172.16~31.x, 10.x)도 허용되어 실기기 테스트에 지장이 없습니다. 등록하신 주소와 완전히 다른 도메인에서 호출하면 E40303 이 반환됩니다. 운영 도메인이 여러 개라면 비토리지로 문의해주세요.',
        app: '앱은 더 주의해야 합니다. 앱에 넣은 키는 디컴파일로 꺼낼 수 있으므로, 앱 화면에서 비토리지 API 를 직접 호출하지 마시고 반드시 자사 서버를 거쳐 호출해주세요.',
        flow: '앱 [Delivery] 버튼 탭 → 자사 서버가 주문연동 API 호출(키는 서버에만 보관) → 응답의 linkToken 과 redirectUrl 을 앱으로 전달 → 앱이 딥링크(btorage://StoreLinkPg?t=…)로 비토리지 앱을 열고, 미설치면 redirectUrl 로 넘김',
        flowNote: 'redirectUrl 은 고객을 되돌려보낼 주소가 아니라 비토리지 진입주소(btorage.com/store/link?t=…)입니다. 딥링크가 실패했을 때 쓰는 대체경로이며, 고객이 비토리지로 넘어온 뒤의 주문·결제는 전부 비토리지에서 끝나므로 자사 앱/서버로 되돌아오는 흐름은 없습니다.',
        leak: '키가 노출된 것 같다면 대시보드에서 바로 [재발급] 하세요. 이전 키는 그 즉시 무효가 됩니다.',
    },

    datasetSpec: [
        ['data-btorage-product', 'O', '이 요소가 하나의 연동 상품임을 표시합니다. (장바구니는 여러 개 반복)'],
        ['data-btorage-name', 'O', '상품명 (최대 255자)'],
        ['data-btorage-option', '', '옵션 (최대 255자). 상품별로 여러 옵션명으로 구성되어 있다면 한 줄로 통합해주세요'],
        ['data-btorage-quantity', 'O', '수량 (1 ~ 9999). 상품별로 총 수량 값을 전달해주세요'],
        ['data-btorage-price', 'O', '상품금액(원). 숫자만. 상품별로 배송료가 제외된 총 상품금액을 전달해주세요 (10,000원 2개 주문 시 값=20,000)'],
        ['data-btorage-mall-ship-price', '', '쇼핑몰 배송비(원). 숫자만'],
        ['data-btorage-url', 'O', '상품 URL (http:// 또는 https:// 로 시작)'],
        ['data-btorage-width', '', '가로(cm). 1~999 숫자만'],
        ['data-btorage-vertical', '', '세로(cm). 1~999 숫자만'],
        ['data-btorage-height', '', '높이(cm). 1~999 숫자만'],
        ['data-btorage-weight', '', '실중량(kg). 999.99 이하 / 소숫점 2자리까지 (예: 100.15)'],
    ],

    /* ── 주문연동 API ────────────────────────────────────────────────────── */
    orderApi: {
        basic: [
            ['Method', 'POST'],
            ['URL', `${BASE}/api/open/v1/order-link`],
            ['Content-Type', 'application/json'],
            ['인증', 'X-BTORAGE-API-KEY 헤더 (또는 apiKey 쿼리 파라미터)'],
            ['비고', '연동토큰은 발급 후 24시간 유효합니다. 남은 유효기간이 12시간 미만일 때 조회하면 자동으로 24시간 연장됩니다.'],
        ],
        headers: [
            ['X-BTORAGE-API-KEY', 'O', '대시보드에서 발급받은 API 키'],
            ['Content-Type', 'O', 'application/json'],
        ],
        request: [
            ['products', 'Array', 'O', '연동 상품 목록 (1 ~ 50개)'],
            ['products[].name', 'String(255)', 'O', '상품명'],
            ['products[].option', 'String(255)', '', '옵션. 상품별로 여러 옵션명으로 구성되어 있다면 한 줄로 통합해주세요'],
            ['products[].quantity', 'Integer', 'O', '수량 (1 ~ 9999). 상품별로 총 수량 값을 전달해주세요'],
            ['products[].price', 'Integer', 'O', '상품금액(원) (0 ~ 100,000,000). 상품별로 배송료가 제외된 총 상품금액을 전달해주세요 (10,000원 2개 주문 시 값=20,000)'],
            ['products[].mallShipPrice', 'Integer', '', '쇼핑몰 배송비(원)'],
            ['products[].url', 'String(500)', 'O', '상품 URL (http/https)'],
        ['products[].wid', 'Integer', '', '가로(cm). 1 ~ 999'],
        ['products[].ver', 'Integer', '', '세로(cm). 1 ~ 999'],
        ['products[].hei', 'Integer', '', '높이(cm). 1 ~ 999'],
        ['products[].weight', 'Float', '', '실중량(kg). 999.99 이하 / 소숫점 2자리까지'],
            ['visitorKey', 'String(64)', '', '고객 구분키. 유입고객 수 중복제거에 사용됩니다.'],
            ['platform', 'String', '', 'WEB | APP (미지정 시 WEB)'],
        ],
        reqExample:
            `POST ${BASE}/api/open/v1/order-link
X-BTORAGE-API-KEY: {{API_KEY}}
Content-Type: application/json

{
  "visitorKey": "v-abc123",
  "platform": "WEB",
  "products": [
    {
      "name": "여성 코튼 니트 가디건",
      "option": "아이보리 / M",
      "quantity": 1,
      "price": 39000,
      "mallShipPrice": 3000,
      "url": "https://myshop.co.kr/product/1234",
      "wid": 41,
      "ver": 31,
      "hei": 28,
      "weight": 10.75
    }
  ]
}`,
        reqCurl:
            `curl -X POST "${BASE}/api/open/v1/order-link" \\
     -H "Content-Type: application/json" \\
     -H "X-BTORAGE-API-KEY: {{API_KEY}}" \\
     -d '{
       "visitorKey": "v-abc123",
       "platform": "WEB",
       "products": [
         {
           "name": "여성 코튼 니트 가디건",
           "option": "아이보리 / M",
           "quantity": 1,
           "price": 39000,
           "mallShipPrice": 3000,
           "url": "https://myshop.co.kr/product/1234",
           "wid": 41,
           "ver": 31,
           "hei": 28,
           "weight": 10.75
         }
       ]
     }'`,
        resExample:
            `HTTP/1.1 200 OK

{
  "success": true,
  "code": "OK",
  "message": "Success",
  "data": {
    "linkToken": "8Kf2xQ1s...",
    "companyName": "마이샵",
    "redirectUrl": "${BASE}/store/link?t=8Kf2xQ1s..."
  }
}`,
    },

    /* ── 배송료조회 API ──────────────────────────────────────────────────── */
    shipApi: {
        basic: [
            ['Method', 'GET'],
            ['URL', `${BASE}/api/shipinfo/checkShippingFee`],
            ['인증', 'X-BTORAGE-API-KEY 헤더 (또는 apiKey 쿼리 파라미터)'],
            ['비고', '국가코드/가로/세로/높이/실무게가 모두 있어야 응답합니다. 관부가세는 조회단계에서 산출 불가합니다.'],
        ],
        request: [
            ['countryCode', 'String(2)', 'O', '수취국가 ISO 코드 (예: US, JP, CA)'],
            ['width', 'Number', 'O', '가로(cm). 0 초과 999 이하'],
            ['height', 'Number', 'O', '세로(cm). 0 초과 999 이하'],
            ['length', 'Number', 'O', '높이(cm). 0 초과 999 이하'],
            ['weight', 'Number', 'O', '실무게(kg). 0 초과 999.99 이하, 소숫점 2자리까지'],
        ],
        reqExample:
            `curl -X GET "${BASE}/api/shipinfo/checkShippingFee?countryCode=US&width=30&height=20&length=15&weight=2.5" \\
     -H "X-BTORAGE-API-KEY: {{API_KEY}}"`,
        responseFields: [
            ['courier', '배송사명 (FedEx / FedEx-E / UPS / UPS-E / EMS / EMS-Premium / K-Packet / Sea-Parcel)'],
            ['dvType', '배송사 식별코드 (D01 / D16 / D11 / D17 / D02 / D15 / D13 / D03)'],
            ['applyWeight', '적용중량(kg). 실무게와 부피중량 중 큰 값을 배송사별 무게구간으로 절상한 값'],
            ['shipCost', '순수 배송료'],
            ['fuelCost', '유류할증료 (FedEx / FedEx-E / UPS / UPS-E 만 존재)'],
            ['fee', '운송수수료 + 25kg 초과 추가운송수수료'],
            ['customFee', '관부가세. 조회단계에서 산출 불가하여 항상 "Uncalculated"'],
            ['finalCost', '최종비용 = shipCost + fuelCost + fee (customFee 제외)'],
        ],
        statusValues: [
            ['Unable To Send', '발송 불가', '미취항 국가 / 배송료 0원 / 무게구간 초과 / 선편 20kg 초과 · 국가별 제한부피 초과 / 뉴질랜드(NZ) 선편'],
            ['Admin Inquiry', '관리자 문의 필요', 'FedEx · FedEx-E · UPS · UPS-E 의 적용중량이 30kg 을 초과한 경우'],
            ['Uncalculated', '산출 불가', 'customFee(관부가세)는 항상 이 값입니다'],
        ],
        resExample:
            `HTTP/1.1 200 OK

{
  "success": true,
  "code": "OK",
  "message": "Success",
  "data": {
    "countryCode": "US",
    "countryNm": "미국",
    "width": "30", "height": "20", "length": "15", "weight": "2.5",
    "fedEx": {
      "courier": "FedEx", "dvType": "D01", "applyWeight": "2.5",
      "shipCost": "48000", "fuelCost": "10320", "fee": "7500",
      "customFee": "Uncalculated", "finalCost": "65820"
    },
    "ems": {
      "courier": "EMS", "dvType": "D02", "applyWeight": "2.5",
      "shipCost": "39000", "fee": "3750",
      "customFee": "Uncalculated", "finalCost": "42750"
    },
    "seaParcel": {
      "courier": "Sea-Parcel", "dvType": "D03", "applyWeight": "4",
      "shipCost": "Unable To Send", "fee": "Unable To Send",
      "customFee": "Unable To Send", "finalCost": "Unable To Send"
    }
  }
}`,
    },

    /* ── 공통 에러 ───────────────────────────────────────────────────────── */
    errorExample:
        `HTTP/1.1 401 Unauthorized

{
  "success": false,
  "code": "E40102",
  "message": "Invalid API key.",
  "detail": null
}`,

    errorCodes: [
        ['E40001', '400', 'Required parameter is missing.', '필수 파라미터가 누락되었습니다. detail 에 누락된 필드명이 담깁니다.'],
        ['E40002', '400', 'Parameter format or range is invalid.', '파라미터 형식 또는 범위가 올바르지 않습니다.'],
        ['E40003', '400', 'Unsupported country code.', '지원하지 않는 국가코드입니다.'],
        ['E40101', '401', 'API key is required.', 'API 키가 전달되지 않았습니다.'],
        ['E40102', '401', 'Invalid API key.', '존재하지 않거나 폐기된 API 키입니다.'],
        ['E40301', '403', 'This store is deactivated. Please contact Btorage.', '비활성화된 상점입니다. 비토리지 관리자 승인이 필요합니다.'],
        ['E40302', '403', 'This store has been withdrawn.', '탈퇴 처리된 상점입니다.'],
        ['E40303', '403', 'This domain is not registered for the API key. Please check your store URL in the Btorage dashboard.',
            '등록되지 않은 도메인에서 호출되었습니다. [내정보]의 자사 URL 을 실제 서비스 주소로 맞춰주세요. (서버에서 직접 호출하는 경우에는 발생하지 않습니다)'],
        ['E50001', '500', 'Internal server error.', '서버 내부 오류입니다. 지속되면 비토리지로 문의해주세요.'],
    ],
};

/* ── 버튼 가이드라인 데이터 ──────────────────────────────────────────────── */
export const BUTTON_GUIDE = {
    themes: [
        // Brand 문구색은 완전한 흰색(#FFFFFF) 으로 고정한다. (주황 바탕 위 가독성/브랜드 일관성)
        {key: 'brand', label: 'Brand (기본)', bg: '#FFBE48', fg: '#FFFFFF', border: 'none', desc: '비토리지 대표색상(#FFBE48). 밝은 배경에 가장 잘 어울립니다.'},
        {key: 'white', label: 'White', bg: '#FFFFFF', fg: '#3A3A3A', border: '1px solid #E2E2E2', desc: '밝은 페이지 / 미니멀한 쇼핑몰에 권장합니다.'},
        {key: 'black', label: 'Black', bg: '#1F2126', fg: '#FFFFFF', border: 'none', desc: '어두운 배경 또는 럭셔리 컨셉에 권장합니다.'},
    ],
    shapes: [
        {key: 'round', label: 'Round', radius: '999px'},
        {key: 'soft', label: 'Soft', radius: '10px'},
        {key: 'square', label: 'Square', radius: '2px'},
    ],
    sizes: [
        {key: 'sm', label: 'Small', height: 36, font: 12.5, logo: 16, padding: 14},
        {key: 'md', label: 'Medium', height: 44, font: 14, logo: 20, padding: 18},
        {key: 'lg', label: 'Large', height: 52, font: 15.5, logo: 24, padding: 22},
    ],
    rules: [
        '버튼 문구는 반드시 [Delivery] 로 고정하며, 임의로 변경할 수 없습니다.',
        '비토리지 로고(btorageBooster)와 문구의 비율/간격을 임의로 변경하지 마세요.',
        '로고를 회전, 왜곡, 단색화, 그림자 추가 등으로 변형할 수 없습니다.',
        '버튼 배경은 제공된 3가지 테마(Brand / White / Black) 중에서만 선택해주세요.',
        '기본 테마인 Brand 의 바탕색은 비토리지 대표색상 #FFBE48 이며, [Delivery] 문구색은 흰색 #FFFFFF 입니다. 두 색상 모두 임의로 변경할 수 없습니다.',
        '버튼 주변에는 버튼 높이의 최소 25% 이상 여백을 확보해주세요.',
        '상품 상세페이지에서는 [구매하기] 버튼 근처에, 장바구니에서는 [주문하기] 근처에 배치하는 것을 권장합니다.',
        '버튼을 이미지로 캡처해 사용하지 마시고 반드시 제공되는 스크립트를 사용해주세요. (해상도 저하 및 기능 미동작)',
    ],
};
